import isEmpty from 'lodash/isEmpty';

import { isLocal } from '../../common/environment';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default (store) => (next) => (action) => {
  if (isLocal) {
    if (console.groupCollapsed && console.groupEnd) {
      if (!isEmpty(action.payload)) {
        let header = `${action.type}\t`;
        if (action.payload.request) {
          header += action.payload.request.url;
        }
        console.groupCollapsed(
          `%c ${header}`,
          'background: #222; color: white;font-weight:bold',
        );
        console.info(action.payload);
        console.groupEnd();
      } else {
        console.info(
          `%c ${action.type}\t`,
          'background: #222; color: #bada55;font-weight:bold',
        );
      }
    } else {
      console.info(action);
    }
  }
  return next(action);
};
